"use client";

import React from "react";

const fieldClass =
  "min-h-11 w-full rounded-lg border border-[#D7D9DE] bg-white px-3 text-sm text-text-primary";

const labelClass = "text-sm font-medium text-text-primary";

/** Fields are specified. The download destination is not wired yet. */
export function HospitalChecklistForm() {
  return (
    <form
      data-lead-magnet="hospital-screen-rollout-checklist"
      className="flex flex-col gap-4"
      onSubmit={event => event.preventDefault()}
    >
      <div className="flex flex-col gap-1.5">
        <label
          id="healthcare-checklist-email-label"
          htmlFor="healthcare-checklist-email"
          className={labelClass}
        >
          Work email
        </label>
        <input
          id="healthcare-checklist-email"
          aria-labelledby="healthcare-checklist-email-label"
          type="email"
          name="email"
          required
          autoComplete="email"
          className={fieldClass}
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <label
          id="healthcare-checklist-organisation-label"
          htmlFor="healthcare-checklist-organisation"
          className={labelClass}
        >
          Organisation
        </label>
        <input
          id="healthcare-checklist-organisation"
          aria-labelledby="healthcare-checklist-organisation-label"
          type="text"
          name="organisation"
          required
          autoComplete="organization"
          className={fieldClass}
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <label
          id="healthcare-checklist-role-label"
          htmlFor="healthcare-checklist-role"
          className={labelClass}
        >
          Your role
          <span className="sr-only"> (optional)</span>
        </label>
        <input
          id="healthcare-checklist-role"
          aria-labelledby="healthcare-checklist-role-label"
          type="text"
          name="role"
          autoComplete="organization-title"
          className={fieldClass}
        />
      </div>
      <button
        type="submit"
        className="inline-flex min-h-11 w-full items-center justify-center rounded-lg bg-primary px-6 text-sm font-medium text-white hover:bg-primary/90"
      >
        Download the Checklist
      </button>
      <p className="text-xs text-text-secondary">No spam. Unsubscribe anytime.</p>
    </form>
  );
}
